<template>
  <a
    v-if="!esconderLinkWhatsapp"
    :href="whatsappThemeLink"
    target="_whatsapp"
    class="link-whatsapp"
    :title="$t('footer.talkToTutor')"
  />

  <div class="footer-top footer-top-u4">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6">
          <div class="footer-widget footer-about">
            <div class="footer-logo">
              <div class="img-fluid bg-logo mb-2" style="width: 100%; height: 40px; display: table"/>
            </div>
            <div class="footer-about-content">
              <p>{{ $t('footer.u4Subtitle') }}</p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6">
          <div class="footer-widget footer-menu">
            <h2 class="footer-title">{{ $t('footer.u4.contactTitle') }}</h2>
            <ul class="footer-u4-contact-list">
              <li>
                <a :href="'tel:' + phoneTel">{{ $t('footer.phone') }}: <strong>{{ $t('footer.u4.phone') }}</strong></a>
              </li>
              <li>
                {{ $t('footer.email') }}:
                <a :href="'mailto:' + $t('footer.u4.email')"><strong>{{ $t('footer.u4.email') }}</strong></a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-lg-4 col-md-12">
          <div class="footer-widget footer-contact">
            <h2 class="footer-title">{{ $t('footer.address') }}</h2>
            <div class="footer-contact-info">
              <div class="footer-address">
                <img src="../assets/img/icon/icon-20.svg" alt="" class="img-fluid">
                <p class="mb-0">{{ $t('footer.u4.addressLine') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row footer-u4-legal mt-4">
        <div class="col-12">
          <div class="footer-widget">
            <h2 class="footer-title footer-title-sm">{{ $t('footer.u4.licensingTitle') }}</h2>
            <p class="footer-u4-text">{{ $t('footer.u4.licensingText') }}</p>
            <p class="footer-u4-text">
              {{ $t('footer.u4.commissionContact') }}
              <a href="https://www.fldoe.org/cie" target="_blank" rel="noopener noreferrer">www.fldoe.org/cie</a>
            </p>
            <p class="footer-u4-text footer-u4-disclaimer">{{ $t('footer.u4.employmentDisclaimer') }}</p>
            <p class="footer-u4-text footer-u4-disclaimer mb-0">{{ $t('footer.u4.nonDiscrimination') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import atividadeSessaoService from '../helpers/atividadeSessao.service'
import { resolveThemeLink } from '../helpers/resolveTheme'

export default {
  name: 'FootertopU4',
  computed: {
    esconderLinkWhatsapp() {
      return atividadeSessaoService.esconderLinkWhatsapp()
    },
    whatsappThemeLink() {
      return resolveThemeLink('u4')
    },
    phoneTel() {
      return this.$t('footer.u4.phone').replace(/\D/g, '')
    },
  },
}
</script>

<style scoped>
.footer-u4-contact-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-u4-contact-list li {
  margin-bottom: 0.5rem;
}

.footer-u4-contact-list a {
  color: inherit;
  text-decoration: none;
}

.footer-u4-contact-list a:hover {
  text-decoration: underline;
}

.footer-u4-legal {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding-top: 1.25rem;
}

.footer-title-sm {
  font-size: 1rem;
  margin-bottom: 0.75rem;
}

.footer-u4-text {
  font-size: 0.875rem;
  line-height: 1.55;
  margin-bottom: 0.65rem;
  opacity: 0.92;
}

.footer-u4-disclaimer {
  font-size: 0.8125rem;
  opacity: 0.85;
}

.footer-top-u4 .footer-address {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
}

.footer-top-u4 .footer-address img {
  flex-shrink: 0;
  margin-top: 0.15rem;
}
</style>
